module.exports = ".property-group {\n  color: #999;\n  font-weight: bold;\n  padding-top: 10px; }\n"